// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Isolation Units API
 * Manage isolation units, clusters and partitions.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Cluster } from './Cluster';
import {
  ClusterFromJSON,
  ClusterFromJSONTyped,
  ClusterToJSON,
  ClusterToJSONTyped,
} from './Cluster';

/**
 *
 * @export
 * @interface Region
 */
export interface Region {
  /**
   *
   * @type {Array<Cluster>}
   * @memberof Region
   */
  clusters?: Array<Cluster>;
  /**
   *
   * @type {string}
   * @memberof Region
   */
  friendlyName?: string;
  /**
   *
   * @type {string}
   * @memberof Region
   */
  name?: string;
}

/**
 * Check if a given object implements the Region interface.
 */
export function instanceOfRegion(value: object): value is Region {
  return true;
}

export function RegionFromJSON(json: any): Region {
  return RegionFromJSONTyped(json, false);
}

export function RegionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Region {
  if (json == null) {
    return json;
  }
  return {
    clusters:
      json['clusters'] == null
        ? undefined
        : (json['clusters'] as Array<any>).map(ClusterFromJSON),
    friendlyName:
      json['friendly_name'] == null ? undefined : json['friendly_name'],
    name: json['name'] == null ? undefined : json['name'],
  };
}

export function RegionToJSON(json: any): Region {
  return RegionToJSONTyped(json, false);
}

export function RegionToJSONTyped(
  value?: Region | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    clusters:
      value['clusters'] == null
        ? undefined
        : (value['clusters'] as Array<any>).map(ClusterToJSON),
    friendly_name: value['friendlyName'],
    name: value['name'],
  };
}
